import React from 'react'
import { connect } from 'react-redux'
import { Chart } from 'react-google-charts'
import { formatarReal } from '../../util/numberUtil'
import { listaCores } from '../../util/constantsUtil'

export class GraficoPorSeguro extends React.Component {

    tooltip(item) {
        const total = this.props.vexadoBI.totalSeguroPorSituacao
            .reduce((s, it) => s + Number(it.valorTotalVendas || 0), 0)
        const pct = total > 0 ? ((Number(item.valorTotalVendas || 0) / total) * 100).toFixed(2) : '0.00'
        return '<div class="google-visualization-tooltip-item">' +
            '<strong style="font-size:16px">' + item.nome + '</strong><br/>' +
            '<span style="font-size:16px"> (Representa=): <strong>' + pct + '%</strong></span><br/>' +
            '<span style="font-size:16px"> (Q.Aprov=): <strong>' + (item.quantidadeVendas || 0) + '</strong></span><br/>' +
            '<span style="font-size:16px"> (Q.Canc=): <strong>' + (item.quantidadeCancelamentos || 0) + '</strong></span><br/>' +
            '<span style="font-size:16px"> (T.Faturado=): <strong>' + formatarReal((item.valorTotalVendas || 0).toString()) + '</strong></span><br/>' +
            '<span style="font-size:16px"> (V.Cancelado=): <strong>' + formatarReal((item.valorTotalCancelamentos || 0).toString()) + '</strong></span><br/>' +
            '<span style="font-size:16px"> (F.Liquid R$=): <strong>' + formatarReal((item.valorTotalVendasLiquido || 0).toString()) + '</strong></span>' +
            '</div>'
    }

    executarDownload(arquivo) {
        const a = window.document.createElement('a')
        a.href = window.URL.createObjectURL(new Blob(['﻿', arquivo], { type: 'text/csv;' }))
        a.download = 'VexBi - Venda de Seguro.csv'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }

    exportar() {
        const dados = this.props.vexadoBI.totalSeguroPorSituacao
        let arquivo = 'Situação;Q.Aprov;Q.Canc;T.Faturado;V.Cancelado;F.Liquido\n'
        arquivo += dados.map(it =>
            `${it.nome};${it.quantidadeVendas || 0};${it.quantidadeCancelamentos || 0};` +
            `"${(it.valorTotalVendas || 0).toString().replace('.', ',')}";` +
            `"${(it.valorTotalCancelamentos || 0).toString().replace('.', ',')}";` +
            `"${(it.valorTotalVendasLiquido || 0).toString().replace('.', ',')}"`
        ).join('\n')
        this.executarDownload(arquivo)
    }

    render() {
        const dados = this.props.vexadoBI.totalSeguroPorSituacao || []
        if (!dados.length) return <div style={{ padding: 20, textAlign: 'center', color: '#999' }}>Sem dados para o período selecionado</div>

        const rows = [['Situação', 'Valor', { role: 'style' }, { role: 'tooltip', type: 'string', p: { html: true } }]]
        dados.forEach((it, i) => rows.push([it.nome, Number(it.valorTotalVendas || 0), listaCores[i % listaCores.length], this.tooltip(it)]))

        return <React.Fragment>
            <Chart
                chartType="ColumnChart"
                data={rows}
                options={{
                    title: 'Venda de Seguro',
                    hAxis: { title: 'Situação' },
                    vAxis: { title: 'Valor (R$)' },
                    legend: { position: 'none' },
                    tooltip: { isHtml: true },
                }}
                width="100%"
                height={this.props.full ? '800px' : '400px'}
            />
            {!this.props.full && <button className="input-group-text bg-white btn-campo-busca float-right" onClick={() => this.props.expandir('seguro')}>Expandir</button>}
            {!this.props.full && <button className="input-group-text btn-laranja btn-campo-busca float-right exportar" onClick={() => this.exportar()}>Exportar Lista</button>}
        </React.Fragment>
    }
}

export function mapStateToProps(state) { return { vexadoBI: state.vexadoBI } }
export default connect(mapStateToProps, {})(GraficoPorSeguro)
